// extracted by mini-css-extract-plugin
export default {"chat":"styles_chat__htWaC","header":"styles_header__YLTbq","assistant-right-panel":"styles_assistant-right-panel__nqj+r"};